import { useSelector } from "react-redux";
import { ResponseTab } from "../../RFIS/ResponstTab";

export const Segmentation = () => {
  const { client_id, client_secret } = useSelector(
    (state) => state.clientSecrets
  );
  return (
    <div className="w-full ">
      {client_id && client_secret && (
        <ResponseTab
          clientSecrets={{ client_id, client_secret }}
          route={"/settings/segmentation?hideNavigation=true"}
          heading={"View Segmentation"}
          desc={"segmentation"}
        />
      )}
    </div>
  );
};
